define( 'uikit/modules/input.date',['require','underscore','backbone','marionette','handlebars','moment','../channel','../mixins/component.mixin','./calendar','../collections/container','./popup','../elements/button','../elements/input','templates','../extra/key.codes'],function(require) {
  var _              = require('underscore'),
      Backbone       = require('backbone'),
      Mn             = require('marionette'),
      Handlebars     = require('handlebars'),
      moment         = require('moment'),

      channel        = require('../channel'),
      ComponentMixin = require('../mixins/component.mixin'),
      Calendar       = require('./calendar'),
      ContainerView  = require('../collections/container'),
      Popup          = require('./popup'),
      ButtonView     = require('../elements/button'),
      Input          = require('../elements/input'),
      Templates      = require('templates'),
      CODES          = require('../extra/key.codes')

  var DATE_REGEX = /([0-9]*)[\/-\s]?([0-9]*)[\/-\s]?([0-9]*)/;

  var DateInput = Mn.ItemView.extend(ComponentMixin).extend({

    options: {
      disabled             : false,
      readonly             : false,
      value                : '',
      icon                 : 'calendar',
      inlineCalendar       : false,
      placeholder          : 'MM-DD-YYYY',
      todayButton          : false,
      format               : 'L',
      fluid                : false,
      // can be startOfDay, endOfDay, a function, or null
      calendarTimeSelector : 'startOfDay',
      // when true, calendar popuop position type will be fixed and
      // offset will be calculated appropriately to position the element
      // correctly; currently only tested with top left and bottom left
      // popup position types
      fixed          : false
    },

    forceUpdate: { disabled: true, inlineCalendar: true },

    template: Templates.App['input.date'],

    events: {
      'click .ui.input': function(ev) {
        var self = this;

        if (this.getOption('disabled')) {
          return;
        }
        if (this.input && this.input.button && ev.target === this.input.button.el) {
          return;
        }
        _.defer(function() {
          var $input = self.input.ui.input;
          if ($input && $input.get(0) !== document.activeElement) {
            self.focus();
          }
        });
      }
    },

    internalViewOptions: function() {
      return {
        input: {
          disabled: this.getBoolOption('disabled'),
          icon: this.getOption('icon'),
          placeholder: this.getOption('placeholder'),
          readonly: this.getBoolOption('readonly'),
          fluid: this.getOption('fluid')
        }
      }
    },

    internalViewBindings: {
      input: {
        fluid: 'fluid'
      }
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);

      this.input.button = new ButtonView({ visible: false, text: 'Today', basic: true, compact: true });

      this.onChangeTodayButton();

      var calendar  = new Calendar({
            selectable: true,
            aligned: 'center'
          }),
          datePopup = false,
          self    = this;

      // we HAVE to add this for bullshit firefox
      calendar.$el.css('width', '295px');

      if (this.inlineCalendar){
        this.inlineView.add(calendar);
      } else {
        datePopup = new Popup({
          showOn: 'manual',
          width: Popup.WIDE,
          position: 'bottom left',
          content: calendar,
          compact: true,
          borderless: true,
          fixed: this.getOption('fixed')
        })
        .attach(this)
      }

      calendar.controls.fluid = true;
      calendar.controls.text.disabled = true;
      this.calendar = calendar;
      this.datePopup = datePopup;

      function onDocumentMouseDown(ev) {
        self._clicky = $(ev.target);
      };

      function onDocumentMouseUp() {
        self._clicky = null;
      };

      $(document)
          .mousedown(onDocumentMouseDown)
          .mouseup(onDocumentMouseUp)


      this
          .on('destroy', function() {
            // unbind everything
            $(document)
                .off('mousedown', onDocumentMouseDown)
                .off('mouseup', onDocumentMouseUp);

            this._destroy(calendar);
            this._destroy(datePopup);
          })
          .listenTo(calendar, 'change:value', this.onChangeCalendarValue)
          .listenTo(calendar, 'day:before:press', this.onCalendarDayPressed)
          .listenTo(this.input.button, 'press', this.onButtonPress)
          .listenTo(this.input, 'change:value', this.onChangeInputValue)
          .listenTo(this.input, 'before:key:code', this.onKeyCode)
          .listenTo(this.input, 'enter', this.onEnter)
          .listenTo(this.input, 'escape', this.onEscape)
          .listenTo(this.input, 'focus', this.onFocus)
          .listenTo(this.input, 'blur', this.onBlur)
          .on('change:value', function(self, value, previous, options) {
            // we have to use vent so that changes from the internal input do not
            // not cause syning back to the input
            if (_.result(options, 'eventSource') !== this) {
              var momentValue = this.value ? moment(this.value) : null;
              this.input._setOption('value', momentValue ? momentValue.format(this.format) : '', {
                eventSource: this
              });
              this.calendar._setOption('value', momentValue, {
                eventSource: this
              });
              if (momentValue && momentValue.isValid()) {
                this.calendar.year  = momentValue.year();
                this.calendar.month = momentValue.month();
              }
              else {
                this.calendar.year  = moment().year();
                this.calendar.month = moment().month();
              }
            }
          });
    },

    _destroy: function(view) {
      if (view instanceof Backbone.View) {
        view.destroy();
      }
    },

    _showCalendar: function() {
        var calendarView = (this.inlineCalendar) ? this.inlineView : this.datePopup;
        calendarView.visible = true;
    },

    _hideCalendar: function() {
        var calendarView = (this.inlineCalendar) ? this.inlineView : this.datePopup;
        calendarView.visible = false;
    },

    onChangeTodayButton: function() {
      this.input.button.visible = this.todayButton;
    },

    focus: function() {
      this.input.focus();
      return this;
    },

    blur: function() {
      this.input.blur();
      return this;
    },

    onButtonPress: function() {
      if (this.todayButton && !(this.readonly || this.disabled)) {
        this.value = +moment();
      }
    },

    formatTime: function(value) {
      var calendarTimeSelector = this.getOption('calendarTimeSelector');
      var momentValue = moment(value);
      if (!value || !momentValue.isValid()) {
        return null;
      }
      else if (calendarTimeSelector == 'startOfDay') {
        return +momentValue.startOf('day');
      }
      else if (calendarTimeSelector == 'endOfDay') {
        return +momentValue.endOf('day');
      }
      else if (_.isFunction(calendarTimeSelector)) {
        var formattedValue = calendarTimeSelector.call(this, momentValue);
        return formattedValue ? +moment(formattedValue) : null;
      }
      else {
        return +momentValue;
      }
    },

    _syncDateValue: function() {
      var value = this.calendar.value;

      this.value = this.formatTime(value);

      // Value change won't be trigger, if already set internally
      this.trigger('change:value', this, this.value, this.value, { internal: true });
    },

    onChangeInputValue: function(self, value, oldValue, options) {
      if (_.result(options, 'eventSource') === this) { return; }

      var value   = String(this.input.value || '').replace(/-/g, '/'), // Firefox does not work with the mm-dd-yyy format
          isValid = !_.isNaN((new Date(value)).getTime()),
          today   = moment(new Date()),
          date    = null;

      if (isValid) {
        var match = value.match(DATE_REGEX),
            month = Number(match[1] || today.format('M'))-1, // Month is zero indexed
            day   = Number(match[2] || today.format('D')),
            year  = Number(match[3] || today.format('YYYY'));

        // black magic to get the right value...
        if (month > 11) {
          year = month+1;
          month = today.month();
        } else if (day > 31) {
          year = day;
          day = today.date();
        }

        if (month < 0) {
          month = 0;
        }

        date = moment(new Date(year, month, day));
      }

      if (date && date.isValid()) {
        this.calendar.value = moment(this.formatTime(date));
        this.calendar.year  = date.year();
        this.calendar.month = date.month();
      } else {
        this.calendar.value = null;
        this.calendar.year  = today.year();
        this.calendar.month = today.month();
      }

      // always set the internal value to the calendar's selected value, unless invalid
      this._setOption('value', this.formatTime(date), {
        eventSource: this
      });
    },

    onCalendarDayPressed: function() {
      this._userDidPress = true;
    },

    onChangeCalendarValue: function(self, value, previousValue, options) {
      var self = this;
      var shouldSyncDateValue = this._userDidPress || !this._userDidTypeValue;

      if (shouldSyncDateValue && _.result(options, 'eventSource') !== this) {
        this._syncDateValue();
        this._hideCalendar();
      }
      this._userDidTypeValue = false;
    },

    onFocus: function() {
      if (!(this.getOption('readonly'))) {
        this._showCalendar();
      }
    },

    onEnter: function() {
      this._syncDateValue();
      this._hideCalendar();
    },

    onEscape: function() {
      this._syncDateValue();
      this._hideCalendar();
    },

    onKeyCode: function(code) {
      // set a flag indicating that we should NOT
      // update the input value from the calendar change
      if (code != CODES.TAB_KEY && code != CODES.ENTER_KEY && code != CODES.ESCAPE_KEY) {
        if (code != CODES.BACKSPACE_KEY || !!this.value) {
          // we only want to set these flags if the code is not a backpace key
          // OR...if it is a backspace character then we need to have a value
          this._userDidPress = false;
          this._userDidTypeValue = true;
        }

        if (!(this.readonly || this.disabled)) {
          this._showCalendar();
        }
      }
    },

    onBlur: function() {
      var self = this,
      calendarView = (this.inlineCalendar) ? this.calendar : this.datePopup,
      clickedElement = this._clicky && this._clicky.get(0),
      isInCalendarView = $.contains(calendarView.$el.get(0), clickedElement),
      isInDayCell = $(clickedElement).hasClass('day cell') || !!$(clickedElement).parents('.day.cell').length;

      if (clickedElement === calendarView.$el.get(0) || isInCalendarView) {
        // we have a click inside the calendarView popup
        // if we passed all that bullshit above.
        // Now let's see if we clicked on an actual date,
        // because we only need to refocus if we did not do so
        if (!isInDayCell) {
          _.defer(function() {
            self.focus();
          });
        }
      } else if (!this.getBoolOption('readonly') && !this.getBoolOption('disabled')) {
        this._hideCalendar();
        if (this._userDidTypeValue) {
          this._syncDateValue();
        }
      }
    },

    onChangePlaceholder: function() {
      this.input.placeholder = this.placeholder;
    },

    onChangeIcon: function() {
      this.input.icon = this.icon;
    },

    onChangeReadonly: function() {
      this.input.readonly = this.getBoolOption('readonly');
    },

    onChangeDisabled: function() {
      this.input.disabled = this.disabled;
    },

    onChangeVisible: function() {
      // make sure the date popup is not visible
      if (!this.visible) {
        this._hideCalendar();
      }
    }

  });

  channel.reply('input-date', function() {
    return DateInput;
  });

  return DateInput;
});

